import { Box, Stack, Text } from "@mantine/core";
import type { CSSProperties, ReactNode } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import type { PluggableList } from "unified";

const wrapStyle: CSSProperties = {
    minWidth: 0,
    maxWidth: "100%",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
    overflowX: "hidden",
};

type DatasourceFormattedTextProps = {
    label: string;
    value: string;
};

export function DatasourceFormattedText({ label, value }: DatasourceFormattedTextProps) {
    return (
        <Stack gap={4} w="100%" style={{ minWidth: 0 }}>
            <Text size="sm" fw={700}>
                {label}:
            </Text>
            <Box className="markdown datasource-formatted-text" w="100%" style={wrapStyle}>
                <Text size="sm" component="div">
                    <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        rehypePlugins={[rehypeRaw] as PluggableList}
                        components={{
                            pre: ({ children }: { children?: ReactNode }) => (
                                <pre style={{ ...wrapStyle, margin: 0 }}>{children}</pre>
                            ),
                            code: ({ children }: { children?: ReactNode }) => (
                                <code style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                                    {children}
                                </code>
                            ),
                        }}
                    >
                        {value}
                    </ReactMarkdown>
                </Text>
            </Box>
        </Stack>
    );
}
